import {useGetTabNames} from "./useGetTabNames";
import {useMemo} from "react";
import {AppTester} from "../../../supporting";
import {useTranslation} from "react-i18next";
import {NAVBAR_TAB_NAMES} from "./const/navbarTabNames";

const TAB_ORDER = ['catalog', 'collection', 'main', 'menu', 'laboratory', 'competencies', 'tags', 'anchors']

export const useGetMobileMenuSettings = (contextTabs: any, menuTabs: any) => {
    const tabNames = useGetTabNames()
    const isDvaDesign = AppTester.isDvaDesign();
    const isGreenAward = AppTester.isGreenAward();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isStartHSE = AppTester.isStartHSE();
    const isHseSpace = AppTester.isHseSpace();
    const isMediiiaNature = AppTester.isMediiiaNature();
    const isHseCreative = AppTester.isCreativeHSE();
    const isKiiidsArt = AppTester.isKiiidsArt();
    const { t } = useTranslation();

    const tabs = useMemo(() => ([{
        key: 'anchors',
        hidden: true,
    },{
        key: 'catalog',
        hidden: true,
    },{
        key: 'collection',
        hidden: true,
    },{
        key: 'main',
        hidden: isHseSpace || isAdcrDafesNet || isGreenAward || isDvaDesign || !Boolean(contextTabs?.length) || isHseCreative || isKiiidsArt,
    },{
        key: 'menu',
        hidden: !Boolean(menuTabs?.length),
    },{
        key: 'laboratory',
        hidden: true,
    },{
        key: 'tags',
        hidden: !(tabNames.includes(NAVBAR_TAB_NAMES.tags)),
    },{
        key: 'competencies',
        hidden: !tabNames.includes(NAVBAR_TAB_NAMES.competencies) && !tabNames.includes(NAVBAR_TAB_NAMES.themes),
    }
    ]), [contextTabs?.length, isDvaDesign, isHseCreative, isKiiidsArt, menuTabs?.length, tabNames, isGreenAward])

    const hiddenTabs = useMemo(() => {
        return tabs.filter(tab => tab?.hidden).map(tab => tab?.key)
    }, [tabs])

    const activeTab = useMemo(() => {
        const actualTabs = TAB_ORDER.filter(tab => !hiddenTabs.includes(tab));
        return actualTabs?.length > 0 ? actualTabs[0] : 'main';
    }, [hiddenTabs])

    const competenciesTabName = useMemo(() => {
        const name = tabNames.findIndex(tab => tab === NAVBAR_TAB_NAMES.themes) !== -1 ? t('nav.themes') : t('nav.competencies')
        return name.slice(0, 1).toUpperCase() + name.slice(1)
    }, [t, tabNames])
    
    const tagsTabName = useMemo(() => {
        const name = isStartHSE ? t("nav.educational_profiles") : isMediiiaNature ? t("nav.choose_date") : t("nav.tags")
        return name.slice(0, 1).toUpperCase() + name.slice(1)
    }, [isStartHSE, t])

    return {
        hiddenTabs: hiddenTabs,
        tabOrder: TAB_ORDER,
        activeTab: activeTab,
        competenciesTabName: competenciesTabName,
        tagsTabName: tagsTabName
    }
}import {useGetTabNames} from "./useGetTabNames";
import {useMemo} from "react";
import {AppTester} from "../../../supporting";
import {useTranslation} from "react-i18next";
import {NAVBAR_TAB_NAMES} from "./const/navbarTabNames";

const TAB_ORDER = ['catalog', 'collection', 'main', 'menu', 'laboratory', 'competencies', 'tags', 'anchors']

export const useGetMobileMenuSettings = (contextTabs: any, menuTabs: any) => {
    const tabNames = useGetTabNames()
    const isDvaDesign = AppTester.isDvaDesign();
    const isGreenAward = AppTester.isGreenAward();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isStartHSE = AppTester.isStartHSE();
    const isHseSpace = AppTester.isHseSpace();
    const isMediiiaNature = AppTester.isMediiiaNature();
    const isHseCreative = AppTester.isCreativeHSE();
    const isKiiidsArt = AppTester.isKiiidsArt();
    const { t } = useTranslation();

    const tabs = useMemo(() => ([{
        key: 'anchors',
        hidden: true,
    },{
        key: 'catalog',
        hidden: true,
    },{
        key: 'collection',
        hidden: true,
    },{
        key: 'main',
        hidden: isHseSpace || isAdcrDafesNet || isGreenAward || isDvaDesign || !Boolean(contextTabs?.length) || isHseCreative || isKiiidsArt,
    },{
        key: 'menu',
        hidden: !Boolean(menuTabs?.length),
    },{
        key: 'laboratory',
        hidden: true,
    },{
        key: 'tags',
        hidden: !(tabNames.includes(NAVBAR_TAB_NAMES.tags)),
    },{
        key: 'competencies',
        hidden: !tabNames.includes(NAVBAR_TAB_NAMES.competencies) && !tabNames.includes(NAVBAR_TAB_NAMES.themes),
    }
    ]), [contextTabs?.length, isDvaDesign, isHseCreative, isKiiidsArt, menuTabs?.length, tabNames, isGreenAward])

    const hiddenTabs = useMemo(() => {
        return tabs.filter(tab => tab?.hidden).map(tab => tab?.key)
    }, [tabs])

    const activeTab = useMemo(() => {
        const actualTabs = TAB_ORDER.filter(tab => !hiddenTabs.includes(tab));
        return actualTabs?.length > 0 ? actualTabs[0] : 'main';
    }, [hiddenTabs])

    const competenciesTabName = useMemo(() => {
        const name = tabNames.findIndex(tab => tab === NAVBAR_TAB_NAMES.themes) !== -1 ? t('nav.themes') : t('nav.competencies')
        return name.slice(0, 1).toUpperCase() + name.slice(1)
    }, [t, tabNames])
    
    const tagsTabName = useMemo(() => {
        const name = isStartHSE ? t("nav.educational_profiles") : isMediiiaNature ? t("nav.choose_date") : t("nav.tags")
        return name.slice(0, 1).toUpperCase() + name.slice(1)
    }, [isStartHSE, t])

    return {
        hiddenTabs: hiddenTabs,
        tabOrder: TAB_ORDER,
        activeTab: activeTab,
        competenciesTabName: competenciesTabName,
        tagsTabName: tagsTabName
    }
}